import React from "react";

/** helpers */
import { useTranslation } from "react-i18next";
import { commonMenuItems } from "../../Views/shared/DropdownMenu/commonMenu.config";
import { useDocTitle } from "../../components/_common/DocTitle";
import useTranslationFromJson from "../../hooks/useTranslationFromJSON";

/** mui */
import { Container, Paper, Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

/** ui */

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 1472,
        marginTop: 0, //120,
        paddingLeft: 40,
    },
    wrapPaper: {
        ...theme.shape.boxedWrapper,
        padding: theme.spacing(3),
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(8),
        [theme.breakpoints.down("xs")]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
    },
    title: {
        fontSize: 32,
        fontWeight: 400,
        color: "#001D77",
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(4),
        textAlign: "center",
    },
    mapUL: {
        fontSize: "1.11111111rem",
        listStyleType: "disc",
        paddingLeft: 21,
        marginTop: 26,
        [theme.breakpoints.down("xs")]: {
            paddingLeft: theme.spacing(3),
        },
    },
    mapLI: {
        marginTop: theme.spacing(3),
        color: "#000000DD",
        "& + &": {
            marginTop: 22,
        },
        [theme.breakpoints.down("xs")]: {
            marginTop: theme.spacing(2),
        },
    },
    mapLink: {
        fontSize: 20,
        color: "#001D77",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    noLink: {
        fontSize: 20,
        color: "#000000DD",
        textDecoration: "none",
    },
    tooltip: {
        maxWidth: 1024,
    },
    topDivider: {
        marginTop: 40,
    },
    bottomDivider: {
        marginTop: 4,
    },
}));

const SiteMap = (props) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    const { translationFromJson } = useTranslationFromJson();
    useDocTitle("Mapa strony - Repozytorium Systemów Informacyjnych");

    const menuItems = [
        {
            id: 0,
            name: "Strona główna",
            name_en: "Homepage",
            link: "/",
            desc: "StronaGłównaOpis",
            tip: "StronaGłównaTip",
             sitemap: ["pl", "en"],
        },
        ...commonMenuItems,
    ].filter((menu) => !menu.mobileOnly && menu.sitemap?.includes(i18n?.language));

    return (
        <>
            <Container maxWidth={false} id="main-content" className={classes.root}>
                <Paper className={classes.wrapPaper} elevation={0}>
                    <Typography variant={"h2"} className={classes.title}>
                        {t("Mapa strony")}
                    </Typography>

                    <Divider className={classes.topDivider} />

                    {!!menuItems?.length && (
                        <ul className={classes.mapUL}>
                            {menuItems?.map((item) => {
                                return (
                                    <li key={item.name} className={classes.mapLI}>
                                        {item.link ? (
                                            <a
                                                href={`${i18n.language === "pl" ? "" : `/${i18n.language}`}${
                                                    item.link
                                                }`}
                                                className={classes.mapLink}
                                            >
                                                {/* {t(`mainmenu.${item.name}`)} */}
                                                {translationFromJson(item, "name")}
                                            </a>
                                        ) : (
                                            <span className={classes.noLink}>
                                                {/* {t(`mainmenu.${item.name}`)} */}
                                                {translationFromJson(item, "name")}
                                            </span>
                                        )}

                                        {!!item?.children?.length && (
                                            <ul className={classes.mapUL}>
                                                {item.children.map((itemChild) => {
                                                    return itemChild.children?.length ? (
                                                        itemChild.children.map((childChild) => {
                                                            return (
                                                                <li key={childChild.name} className={classes.mapLI}>
                                                                    <a
                                                                        // href={"#" + childChild.link}
                                                                        href={`${
                                                                            i18n.language === "pl"
                                                                                ? ""
                                                                                : `/${i18n.language}`
                                                                        }${childChild.link}`}
                                                                        className={classes.mapLink}
                                                                    >
                                                                        {/* {`${t(`mainmenu.${itemChild.name}`)} - ${t(
                                                                            `mainmenu.${childChild.name}`
                                                                        )}`} */}
                                                                        {`${translationFromJson(
                                                                            itemChild,
                                                                            "name"
                                                                        )} ${translationFromJson(childChild, "name")}`}
                                                                    </a>
                                                                </li>
                                                            );
                                                        })
                                                    ) : (
                                                        <li key={itemChild.name} className={classes.mapLI}>
                                                            <a
                                                                // href={"#" + itemChild.link}
                                                                href={`${
                                                                    i18n.language === "pl" ? "" : `/${i18n.language}`
                                                                }${itemChild.link}`}
                                                                className={classes.mapLink}
                                                            >
                                                                {/* {t(`mainmenu.${itemChild.name}`)} */}
                                                                {translationFromJson(itemChild, "name")}
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    )}

                    <Divider className={classes.bottomDivider} />
                </Paper>
            </Container>
        </>
    );
};

export default SiteMap;
